import React from "react";
import { Container } from "react-bootstrap";

export default function AccountPage() {
  return <Container fluid={true}>Account</Container>;
}
